import {
  herb,
  hcv,
  member,
  localization,
  plot
} from './plot-objects'

const modulePlot = {
  namespaced: true,
  state: {
    id: null,
    herb: { ...herb },
    hcv: { ...hcv },
    localization: { ...localization },
    localizationTmp: {},
    member: { ...member },
    team: [{ ...member }],
    teamTmp: [],
    plot: { ...plot },
    plotTmp: {},
    typeInfo: {}
  },
  getters: {
    plot: (state, getters) => {
      return {
        localization: state.localization,
        team: state.team,
        plot: state.localization.plotType === '01' ? getters.forestPlot : getters.eventPlot,
        typeInfo: state.typeInfo
      }
    },

    teamLength: state => {
      return state.team.length
    },

    forestPlot: state => {
      return {
        plot_num: state.plot.plot_num,
        plot_sample: state.plot.plot_sample,
        slope: state.plot.slope,
        elevation: state.plot.elevation,
        plot_type: state.plot.plot_type,
        coords: {
          latitude: state.plot.coords.latitude,
          longitude: state.plot.coords.longitude
        },
        note: state.plot.note
      }
    },

    eventPlot: state => {
      return {
        event_num: state.plot.event_num,
        event_type: state.plot.event_type,
        note: state.plot.note
      }
    }
  },
  mutations: {
    setId: function (state, id) {
      state.id = id
    },

    clearState: function (state, type) {
      switch (type) {
        case 'typeInfo':
          state.typeInfo = {}
          break
        case 'team':
          state.team = []
          state.team.push(member)
          break
        case 'localization':
          state.localization = { ...localization }
          break
        case 'plot':
          state.plot = { ...plot }
          break
        default:
          break
      }
    },

    clearTmp: function (state, type) {
      state[type + 'Tmp'] = {}
    },

    getPlot: function (state, plot) {
      plot.db.getItem(plot.id).then(value => {
        state.localization = value.localization
        state.team = value.team
        state.plot = value.plot
        state.typeInfo = value.typeInfo
      }).catch(err => {
        console.log(err)
      })
    },

    setTypeInfo: function (state, typeInfo) {
      state.typeInfo = JSON.parse(JSON.stringify(typeInfo))
    },

    setNonwood: function (state, nonwood) {
      state.typeInfo['nonwood'] = nonwood
    }
  },
  actions: {
    setTmp: function ({ state }, type) {
      if (type === 'team') {
        state[type + 'Tmp'] = []
        state[type].forEach(k => {
          state[type + 'Tmp'].push(k)
        })
      } else {
        state[type + 'Tmp'] = JSON.parse(JSON.stringify(state[type]))
      }
    },

    getTmp: function ({ state }, type) {
      if (type === 'team') {
        if (state[type + 'Tmp'].length > 0) {
          state[type] = []
          state[type + 'Tmp'].forEach(k => {
            state[type].push(k)
          })
        }
      } else {
        if (Object.keys(state[type + 'Tmp']).length > 0) {
          state[type] = JSON.parse(JSON.stringify(state[type + 'Tmp']))
        }
      }
    }
  }
}

export default modulePlot
